var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit, Prop } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { LabelingStrategyService } from "~/services/dataimp-service/labeling-strategy-service";
var RunRecordOfTheDay = /** @class */ (function (_super) {
    __extends(RunRecordOfTheDay, _super);
    function RunRecordOfTheDay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            caseInfoRecordCurrentCollectorRealName: "",
            caseNumber: "",
            deptName: "",
            personalInfoPersonalName: "",
            latelyDatetime: [],
            batchNumber: "",
            labelId: ""
        };
        _this.dataSet = [];
        return _this;
    }
    // @Watch("batchNumber")
    // private onBatchNumberChange(val) {
    //   this.dataSet = [];
    //   this.pageService.reset();
    //   this.refreshData();
    // }
    // @Watch("labelId")
    // private onLabelIdChange(val) {
    //   this.dataSet = [];
    //   this.pageService.reset();
    //   this.refreshData();
    // }
    RunRecordOfTheDay.prototype.close = function () {
        this.resetData();
    };
    RunRecordOfTheDay.prototype.resetData = function () {
        this.model.caseNumber = "";
        this.model.labelId = "";
        this.model.deptName = "";
        this.model.latelyDatetime = [];
        this.model.personalInfoPersonalName = "";
        this.model.caseInfoRecordCurrentCollectorRealName = "";
    };
    RunRecordOfTheDay.prototype.mounted = function () {
        this.refreshData();
    };
    RunRecordOfTheDay.prototype.refreshData = function () {
        var _this = this;
        this.model.batchNumber = this.batchNumber;
        this.model.labelId = this.labelId;
        this.labelingStrategyService
            .queryLabelDetailData(this.model, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(LabelingStrategyService)
    ], RunRecordOfTheDay.prototype, "labelingStrategyService", void 0);
    __decorate([
        Dependencies(PageService)
    ], RunRecordOfTheDay.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RunRecordOfTheDay.prototype, "sortService", void 0);
    __decorate([
        Prop()
    ], RunRecordOfTheDay.prototype, "batchNumber", void 0);
    __decorate([
        Prop()
    ], RunRecordOfTheDay.prototype, "labelId", void 0);
    __decorate([
        Emit("close")
    ], RunRecordOfTheDay.prototype, "close", null);
    RunRecordOfTheDay = __decorate([
        Component
    ], RunRecordOfTheDay);
    return RunRecordOfTheDay;
}(Vue));
export default RunRecordOfTheDay;
